import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

export default function StatsPerfil({ stats }) {
  return (
    <div className="flex flex-col w-[99%] mt-6 bg-aw-gray rounded-lg px-2 py-4 justify-between">
      <div className="flex flex-row w-full justify-between sm:justify-around px-4 sm:px-14">
        {stats.map((stat, indexStat) => (
          <div key={indexStat} className={`text-${stat.colorName} text-xs`}>
            {stat.icon != null && (
              <FontAwesomeIcon
                icon={`fa-solid fa-${stat.icon}`}
                className="mr-2 "
              />
            )}
            {stat.statName}
          </div>
        ))}
      </div>
      <div className="flex w-full text-center mt-2 bg-aw-bluedark rounded-lg px-4 sm:px-0 py-2 justify-between sm:justify-evenly">
        {stats.map((stat, indexStat) => (
          <div
          key={indexStat}
            className={`flex justify-between items-center gap-x-4 px-4 sm:px-14${
              indexStat == 1 ? " border-x border-gray-400" : ""
            }`}
          >
            {stat.stats.map((stt, indexStt) => (
              <div key={`${indexStat}-${indexStt}`} className="flex-1 flex flex-col items-center">
                <span className="text-aw-green text-lg sm:text-2xl font-bold">
                  {stt.count}
                </span>
                <span className="text-gray-200 text-[0.65rem] sm:text-sm mt-0.5">
                  {stt.label}
                </span>
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
